"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsSearched = exports.searchStarted = void 0;
const constants_1 = require("../constants");
exports.searchStarted = ({ stats, session }) => {
    const props = {
        [constants_1.EventProperty.SEARCH_START_TOTAL]: stats.totalSearchStart,
        [constants_1.EventProperty.USER_ID]: session.userID,
        [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
        [constants_1.EventProperty.SESSION_ID]: session.sessionID
    };
    window.analytics.track(constants_1.EventName.SEARCH_STARTED, props);
};
exports.productsSearched = ({ stats, session, }) => {
    const props = {
        [constants_1.EventProperty.SEARCH_RESULTS]: stats.totalResults,
        [constants_1.EventProperty.SEARCH_TERM]: stats.term,
        [constants_1.EventProperty.SEARCH_TOTAL]: stats.totalSearches,
        [constants_1.EventProperty.USER_ID]: session.userID,
        [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
        [constants_1.EventProperty.SESSION_ID]: session.sessionID,
    };
    window.analytics.track(constants_1.EventName.PRODUCTS_SEARCHED, props);
};
